import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { FretDivider, KanjiBackdrop, Seal } from './Ornaments';
import { bonuses, tomes } from '../data/bonuses';
const atlasCoverUrl = 'https://cdn.magicpatterns.com/uploads/dB76DHoBKWaoyqWyupcZ3h/Portada_Atlas_ancestral_de_acupuntura.png';
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-172" data-mp="dtu63fwrzxyk">
      <KanjiBackdrop glyphs={['經', '絡', '穴', '脈', '藥']} data-id="element-173" data-mp="dv58pcehizo3" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-174" data-mp="isnn3ib9u73h">
        <span className="inline-flex items-center gap-1.5 rounded-sm border border-brand-gold/60 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-brand-forest shadow-sm" data-id="element-175" data-mp="isdqvczmv3pc">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-176" data-mp="91auuplk9ewx" />
          Mirá el atlas por dentro
        </span>
        <h2 className="mt-3 font-display text-[28px] font-bold leading-[1.02] text-brand-ink sm:text-4xl md:text-5xl" data-id="element-177" data-mp="11j508ejmeu3q">
          Sin teoría interminable, sin libros de 500 páginas que nunca se usan en
          consulta:{' '}
          <span className="relative z-0 inline-block px-1.5 text-brand-burgundy before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.4em] before:-rotate-1 before:rounded-sm before:bg-brand-goldLight/90" data-id="element-178" data-mp="3k9co4hp30vjg">
            el punto exacto
          </span>
          , la imagen exacta, la técnica exacta.
        </h2>

        <div className="mx-auto mt-8 max-w-[260px] overflow-hidden rounded-md border border-brand-gold/50 shadow-[0_14px_40px_rgba(44,38,32,0.15)] sm:max-w-[320px] md:mt-10" data-id="element-179" data-mp="bukvj7wv811j">
          <video autoPlay loop muted playsInline className="w-full object-cover" data-id="element-180" data-mp="lpcvgidx6zzh">
            <source src="https://cdn.magicpatterns.com/uploads/9SmWXvArkpjuPrTrk6mWwW/Scroll_Acupuntura_magic.mp4" type="video/mp4" data-id="element-181" data-mp="gsme7rqdpych" />
            Tu navegador no soporta la reproducción de videos.
          </video>
        </div>
      </div>

      <div className="paper-card mx-auto mt-8 max-w-5xl rounded-sm border border-brand-gold/45 p-5 shadow-[0_14px_40px_rgba(44,38,32,0.09)] md:p-8" data-id="element-182" data-mp="2il0tej1jgop7">
        <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:items-center sm:gap-8 sm:text-left" data-id="element-183" data-mp="3c7wx2y660cdy">
          <img src={atlasCoverUrl} alt="Portada del Atlas Ancestral de Acupuntura" className="w-40 shrink-0 rounded-sm border border-brand-gold/50 bg-brand-surfaceLight/40 object-contain shadow-[0_12px_28px_rgba(44,38,32,0.2)] sm:w-48 md:w-56" loading="lazy" decoding="async" data-id="element-184" data-mp="3h7042o5pgsok" />
          <div className="min-w-0" data-id="element-185" data-mp="3v6raa2pzd4s0">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-burgundy" data-id="element-186" data-mp="3v5q0s2om4qce">
              El pack principal
            </span>
            <h3 className="mt-1.5 font-serif text-2xl font-bold leading-tight text-brand-ink md:text-[2rem]" data-id="element-187" data-mp="8shntz5m26tv">
              ATLAS ANCESTRAL DE ACUPUNTURA™
            </h3>
            <p className="mt-3 max-w-xl font-display text-lg leading-snug text-brand-text md:text-xl" data-id="element-188" data-mp="dp84oop8p6gc">
              Tu sistema visual completo para localizar el punto correcto,
              aplicarlo con técnica precisa y respaldarte con criterio clínico en
              cada sesión.
            </p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.12em] text-brand-goldDark" data-id="element-189" data-mp="1ta0n3e6vfnl4">
              3 tomos · 118 páginas · 26 protocolos clínicos
            </p>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-4 divide-x divide-brand-gold/35 rounded-sm border border-brand-gold/40 bg-brand-surfaceLight/45 px-2 py-3 text-center" data-id="element-190" data-mp="2lyen1zhistzb">
          <div className="px-1" data-id="element-191" data-mp="2h0d1n7wmgiko">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-192" data-mp="2c8laow9k0au0">
              3
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-193" data-mp="27ajpo5ski1fw">
              tomos
            </span>
          </div>
          <div className="px-1" data-id="element-194" data-mp="2zyfnjdtvhze9">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-195" data-mp="2zy775byjkbyb">
              118
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-196" data-mp="2keuvvqy8pofj">
              páginas
            </span>
          </div>
          <div className="px-1" data-id="element-197" data-mp="2airwutyoq5wt">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-198" data-mp="2ajt6qv3ysmcy">
              26
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-199" data-mp="2fj62k5ctd3ro">
              protocolos
            </span>
          </div>
          <div className="px-1" data-id="element-200" data-mp="384p949mh1f0b">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-201" data-mp="387utxco2huq8">
              50+
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-202" data-mp="2yfp3w8hdlndo">
              puntos
            </span>
          </div>
        </div>

        <ul className="mt-6 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-203" data-mp="3qwhyzv68uk3t">
          {tomes.map(tome => <li key={tome.label} className="flex gap-3 md:flex-col md:gap-3" data-id="element-204" data-mp="3qykzxa8xpxnb">
              <div className="relative mt-0.5 w-14 shrink-0 md:mx-auto md:mt-0 md:w-24" data-id="element-205" data-mp="1ffyajemgleiv">
                <img src={tome.cover} alt={`Portada del ${tome.label}: ${tome.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-full rounded-sm border border-brand-ink/25 bg-brand-ink object-cover shadow-[0_6px_14px_rgba(44,38,32,0.22)]" data-id="element-206" data-mp="1ahn0b2s95204" />
                <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-sm border border-brand-gold/60 bg-brand-paper font-kanji text-[10px] text-brand-goldDark" aria-hidden="true" data-id="element-207" data-mp="wiewfwl595pl">
                  {tome.numeral}
                </span>
              </div>
              <div className="min-w-0 md:text-center" data-id="element-208" data-mp="11hzxqdnsdq5h">
                <p className="font-serif text-sm font-bold text-brand-ink" data-id="element-209" data-mp="11g6rv0kzz9yj">
                  <span className="uppercase tracking-[0.08em] text-brand-burgundy" data-id="element-210" data-mp="2gxgybw5ajlii">
                    {tome.label}
                  </span>{' '}
                  — {tome.title}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-brand-muted" data-id="element-211" data-mp="19ky2dpgpc120">
                  {tome.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 border-t border-brand-gold/30 pt-4 text-sm leading-relaxed text-brand-muted md:text-center" data-id="element-212" data-mp="1jjx9v4pqdqnf">
          Localización exacta del punto, meridiano de pertenencia, órgano
          asociado, técnica de inserción y acción terapéutica en una consulta
          rápida.
        </p>
      </div>

      <FretDivider character="贈" className="mt-14" data-id="element-213" data-mp="vvnsqg3gpr2m" />
      <div className="mt-6 text-center" data-id="element-214" data-mp="zw7qnlvv0ypt">
        <h3 className="flex flex-wrap items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-215" data-mp="zv4yzbqpqs8u">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-216" data-mp="14oh9yj2gz0j4" />
          6 BONOS ESTRATÉGICOS —
          <span className="text-brand-forest" data-id="element-217" data-mp="82xjwfquvnwk">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-218" data-mp="c52a14i3i2eg">
        {bonuses.map(bonus => <article key={bonus.n} className="min-w-0" data-id="element-219" data-mp="4l00it54ycg8">
            <div className="aspect-[3/4] overflow-hidden rounded-sm border border-brand-ink/25 bg-brand-ink shadow-[0_10px_24px_rgba(44,38,32,0.22)]" data-id="element-220" data-mp="3vugn5ujkfwyj">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-221" data-mp="3rtn0f4hv0o78" />
            </div>
            <p className="mt-2 text-center text-[10px] font-bold uppercase tracking-wide text-brand-burgundy" data-id="element-222" data-mp="3huxgl66ektoc">
              Bono {bonus.n} — {bonus.title}
            </p>
            <p className="mt-1 min-h-[3.75rem] text-center text-[10px] leading-tight text-brand-muted" data-id="element-223" data-mp="384um11jmv7nw">
              {bonus.description}
            </p>
            <p className="mt-2 text-center text-[10px] text-brand-muted" data-id="element-224" data-mp="2z34xc3h4ymtt">
              <span className="line-through" data-id="element-225" data-mp="2z57mklagsbxh">{bonus.price}</span>{' '}
              <strong className="text-brand-forest" data-id="element-226" data-mp="2u5cvagms1kbw">→ GRATIS</strong>
            </p>
          </article>)}
      </div>
      <div className="mt-8 flex justify-center" data-id="element-227" data-mp="lvv9wentf7me">
        <span className="inline-flex items-center gap-3 rounded-sm border border-brand-gold/55 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-228" data-mp="qu6k4qi0vk55">
          <Seal characters="贈禮" className="h-9 w-9 text-[11px]" data-id="element-229" data-mp="cudzncx3a05m" />
          <span data-id="element-230" data-mp="hsp93mjh28nb">
            Valor total de los bonos{' '}
            <span className="text-brand-muted line-through" data-id="element-231" data-mp="34ug051jy29p">$76.000 ARS</span>{' '}
            <strong className="text-brand-forest" data-id="element-232" data-mp="32rhewmc30td">
              → GRATIS con tu Atlas Ancestral
            </strong>
          </span>
        </span>
      </div>
    </Section>;
}